import { render, staticRenderFns } from "./TargetsModal.vue?vue&type=template&id=1b58c88a&"
import script from "./TargetsModal.vue?vue&type=script&lang=js&"
export * from "./TargetsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports